import React, { useCallback } from "react";
import { Typography, Chip, Stack } from "@mui/material";
import { Cancel as NotBilledIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import SchoolStatusTable from "../components/schools/SchoolStatusTable";
import apiService from "../services/apiService";
import { crmColors } from "../theme/colors";

const formatDate = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? value : d.toLocaleDateString();
};

//Created By Cursor — Demo / Demo Not Start / Demo expired chips
const statusChip = (row) => {
  const raw = String(row.display_status || row.status || row.demo_status || "Not Billed");
  const lower = raw.toLowerCase();
  const expired = Boolean(row.demo_expired) || /expired/i.test(lower);
  const notStart = /not start/i.test(lower);
  let bgcolor = crmColors.secondary.main;
  if (expired) bgcolor = crmColors.error.main;
  else if (notStart) bgcolor = crmColors.warning.main;
  else if (/demo/i.test(lower)) bgcolor = crmColors.info.main;

  const label =
    expired && row.demo_label
      ? row.demo_label
      : /demo/i.test(lower) && row.demo_label && !notStart
        ? `Demo · ${row.demo_label}`
        : raw;

  return (
    <Chip
      size="small"
      label={label}
      sx={{
        fontWeight: 800,
        height: 24,
        borderRadius: "8px",
        color: "#fff",
        bgcolor,
        maxWidth: 200,
      }}
    />
  );
};

const NotBilledSchools = () => {
  const navigate = useNavigate();

  const fetchRows = useCallback(
    () => apiService.getNotBilledSchools({ limit: 500, offset: 0 }),
    []
  );

  return (
    <SchoolStatusTable
      title="Not Billed Schools"
      subtitle="Schools without an Active paid account (Demo / Demo Not Start / Demo expired)"
      breadcrumbLabel="Not Billed Schools"
      breadcrumbIcon={<NotBilledIcon sx={{ color: "#ffffff", fontSize: 18 }} />}
      fetchRows={fetchRows}
      onRowClick={(row) => {
        if (row?.school_code) {
          navigate(`/schools/detail/${encodeURIComponent(row.school_code)}`);
        }
      }}
      searchFields={(row) => [
        row.school_name,
        row.school_code,
        row.admin_name,
        row.admin_phone,
        row.state,
        row.country,
        row.display_status,
        row.status,
        row.demo_status,
      ]}
      columns={[
        {
          id: "name",
          label: "School",
          render: (row) => (
            <Stack spacing={0.15}>
              <Typography variant="body2" sx={{ fontWeight: 700 }}>
                {row.school_name}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {row.school_code || "—"}
              </Typography>
            </Stack>
          ),
        },
        {
          id: "contact",
          label: "Contact",
          render: (row) => (
            <Stack spacing={0.15}>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {row.admin_name || "—"}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {row.admin_phone || "—"}
              </Typography>
            </Stack>
          ),
        },
        {
          id: "location",
          label: "Location",
          render: (row) => [row.state, row.country].filter(Boolean).join(", ") || "—",
        },
        {
          id: "status",
          label: "Status",
          render: (row) => statusChip(row),
        },
        {
          id: "added",
          label: "Added",
          render: (row) => formatDate(row.date_added),
        },
      ]}
    />
  );
};

export default NotBilledSchools;
